// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"PartnerTransactionDetails_delimiter_2Wkuz","footer":"PartnerTransactionDetails_footer_1z-oI","footerLink":"PartnerTransactionDetails_footerLink_nu2aY"};